var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FF4D4F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5c5.798 0 10.5 4.702 10.5 10.5S17.798 22.5 12 22.5 1.5 17.798 1.5 12 6.202 1.5 12 1.5zm0 1.75c-4.833 0-8.75 3.917-8.75 8.75s3.917 8.75 8.75 8.75 8.75-3.917 8.75-8.75S16.832 3.25 12 3.25zM9.47 8.322l.113.096L12 10.835l2.417-2.418c.322-.323.844-.323 1.166 0 .287.286.319.73.096 1.052l-.096.114L13.165 12l2.418 2.417c.323.322.323.844 0 1.166-.286.287-.73.319-1.052.096l-.114-.096L12 13.165l-2.417 2.418c-.322.323-.844.323-1.166 0-.287-.286-.319-.73-.096-1.052l.096-.114L10.835 12 8.416 9.583c-.323-.322-.323-.844 0-1.166.286-.287.73-.319 1.052-.096z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFail);
export default __webpack_public_path__ + "static/media/icon-fail.96468606.svg";
export { ForwardRef as ReactComponent };